let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kkyrw")).then(() => parcelRequire('8Jdvp'));